/*!
 * Developed by Markant
 */
/**
 * Holds Device Information
 */
class DeviceInformation {
    constructor() {
        this.isTouch = this._isTouch();
    }
    _isTouch() {
        const hasOnTouchStart = 'ontouchstart' in window;
        const hasMaxTouchPoints = (navigator === null || navigator === void 0 ? void 0 : navigator['maxTouchPoints']) && navigator['maxTouchPoints'] > 0;
        const hasMsMaxTouchPoints = (navigator === null || navigator === void 0 ? void 0 : navigator['msMaxTouchPoints']) && navigator['msMaxTouchPoints'] > 0;
        return hasOnTouchStart || hasMaxTouchPoints || hasMsMaxTouchPoints;
    }
}
const Device = new DeviceInformation();

export { Device as D };
